import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import ja from 'date-fns/locale/ja'
import format from 'date-fns/format'

type Props = {
  date: Date
}

const RevenueListHeader: FC<Props> = (props) => {
  const { date } = props
  return <p className={styles.revenue__header}>{format(date, 'yyyy年M月d日(E)', { locale: ja })}</p>
}

export default RevenueListHeader
